<template>
  <sidebar-layout-item class="cmp-contact-form-user-data">
    <q-form ref="form" novalidate>
      <h5>
        {{ $t('scf.user_data.title') }}
      </h5>
      <small>
        {{ $t('scf.user_data.info') }}
      </small>

      <ws-btn-toggle
        v-model="userExistence"
        class="q-mt-2xl"
        :options="[
          { value: 'new', label: 'scf.user_data.new' },
          { value: 'old', label: 'scf.user_data.old' },
        ]"
      />

      <contact-form-user-new
        v-if="userExistence === 'new'"
        v-model="model.contact"
        class="q-mt-lg"
      />

      <contact-form-user-old
        v-else-if="userExistence === 'old'"
        v-model="model"
        class="q-mt-lg"
        @loading="loading = $event"
      />

      <ws-input
        v-if="usecase === CF_USECASE.MANAGEMENT"
        v-model="model.note"
        type="textarea"
        class="ws-textarea"
        autogrow
        banner
        messages-overflow
        :label="$t('scf.user_data.note')"
        debounce="300"
        @input="reEmit"
      />

      <ws-input
        v-if="usecase === CF_USECASE.MONITORING"
        v-model="model.name"
        name="name"
        class="server-name"
        :label="$t('scf.user_old.server_name')"
        :path="'scf.name'"
        required
        :rules="[required, ...serverNameRules]"
        :restrict="serverNameRestriction"
        @input="reEmit"
      />

      <consent-checkboxes
        ref="consents"
        force-required
        class="text-left q-mt-2xl"
      />
    </q-form>
  </sidebar-layout-item>
</template>

<script lang="ts">
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { QForm } from 'quasar';
import {
  validateForm,
  required,
  addValidations,
  productPropertyList,
  propertyRestriction,
  propertyRules,
} from '@/services/validation/validation.service.ts';
import type { Validator } from '@/services/validation/validation.service.d';
import WsInput from '@WS_Components/WsInput.vue';
import WsBtnToggle from '@WS_Components/WsBtnToggle.vue';
import SidebarLayoutItem from '@/components/SidebarLayoutItem.vue';
import ConsentCheckboxes from '@/components/ConsentCheckboxes.vue';
import PricePeriod from '@/components/PricePeriod.vue';
import { CF_USECASE } from './const.enum';
import ContactFormUserNew from './ContactFormUserNew.vue';
import ContactFormUserOld from './ContactFormUserOld.vue';

@Component({
  components: {
    QForm,
    WsInput,
    WsBtnToggle,
    SidebarLayoutItem,
    ConsentCheckboxes,
    PricePeriod,
    ContactFormUserNew,
    ContactFormUserOld,
  },
})
export default class ContactFormUserData extends Vue {
  @Prop()
  readonly usecase!: string;
  @Prop({ default: () => ({ contact: {} }) })
  readonly value!: any;
  @Prop({ default: () => ({}) })
  readonly productOptions!: any;

  loading = false;
  public userExistence = 'old';
  CF_USECASE = CF_USECASE;
  required = required;
  serverNameRules!: Validator[];
  serverNameRestriction!: string;

  get model() {
    return { ...this.value };
  }
  set model(value: any) {
    this.$emit('input', value);
  }

  created() {
    addValidations([productPropertyList]);
    this.serverNameRestriction = propertyRestriction('server_name');
    this.serverNameRules = propertyRules('server_name');
  }

  @Watch('usecase')
  onNoteChange(usecase: string) {
    if (usecase === this.CF_USECASE.MANAGEMENT) {
      Vue.set(this.model, 'note', '');
    }
  }

  public async validate() {
    const consentCheckboxesCmp = this.$refs.consents as ConsentCheckboxes;
    const result = await validateForm(this.$refs.form as Element & QForm);
    if (!result || !consentCheckboxesCmp?.validateCheckboxes?.()) {
      return false;
    }

    this.model.termsAndConditionsConsent =
      consentCheckboxesCmp.termsAndConditionsConsent;
    this.model.thirdPartyConsent = consentCheckboxesCmp.thirdPartyConsent;

    this.reEmit();
    return true;
  }

  reEmit() {
    this.$emit('input', this.model);
  }
}
</script>

<style lang="scss" scoped>
.cmp-contact-form-user-data {
  .theme--cary & {
    @include ws-top-stripe;
  }
  position: relative;

  .ws-textarea {
    margin-top: 6px;
  }

  .server-name {
    margin-top: 6px;
  }
}
</style>
